import React from 'react';
import './Sales.css';

const products = [
  { icon: 'bi-moisture', label: 'Dehumidifiers' },
  { icon: 'bi-wind', label: 'Air Handling Units (AHUs)' },
  { icon: 'bi-circle-square', label: 'Desiccant Rotors' },
  { icon: 'bi-cpu', label: 'All Types of Motors' },
  { icon: 'bi-lightning-charge', label: 'Electrical Components' },
  { icon: 'bi-motherboard', label: 'Electronic Components' },
  { icon: 'bi-grid-3x3-gap', label: 'Electrical Panels' },
  { icon: 'bi-fire', label: 'Industrial Hot Air Ovens' },
];

const reasons = [
  { icon: 'bi-award', text: 'High quality & industry standards on every product' },
  { icon: 'bi-truck', text: 'Reliable supply chain with timely delivery' },
  { icon: 'bi-headset', text: 'Dedicated sales team for expert guidance' },
  { icon: 'bi-patch-check', text: 'Sourced from trusted, verified manufacturers' },
];

function Sales() {
  return (
    <section className="sales-section" id="sales">
      <div className="container">
        <div className="row align-items-center g-5">

          {/* Left */}
          <div className="col-lg-5">
            <div className="section-eyebrow">Products</div>
            <h2 className="section-title">Quality Products,<br />Delivered Reliably</h2>
            <p className="section-sub">
              We have a dedicated sales segment supplying a wide range of high-quality
              equipment, components and systems for industrial and commercial use across India.
            </p>

            <div className="sales-reasons mt-4">
              {reasons.map((r, i) => (
                <div className="sales-reason" key={i}>
                  <i className={`bi ${r.icon} reason-icon`}></i>
                  <span>{r.text}</span>
                </div>
              ))}
            </div>

            <a href="#contact" className="btn-ats-primary mt-4 d-inline-block"
              onClick={e => { e.preventDefault(); document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' }); }}>
              <i className="bi bi-envelope me-2"></i>Request a Quote
            </a>
          </div>

          {/* Right — product grid */}
          <div className="col-lg-7">
            <div className="products-box">
              <div className="products-box-header">
                <i className="bi bi-box-seam me-2"></i> Products We Supply
              </div>
              <div className="products-grid">
                {products.map((p, i) => (
                  <div className="product-item" key={i}>
                    <i className={`bi ${p.icon} product-icon`}></i>
                    <span className="product-label">{p.label}</span>
                  </div>
                ))}
              </div>
              <div className="products-note">
                <i className="bi bi-info-circle me-2"></i>
                All products sourced and supplied with the highest quality standards for long-term reliability.
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Sales;
